import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { claimScrollRestoration } from './lib/grid-anchor';
import { listenForStaleBuild } from './lib/stale-build';
import { router } from './router';

// Tailwind first (layered), brand styles second (unlayered, so they win where they overlap).
import '../styles/tailwind.css';
import '../styles/global.scss';

// Said once, about the document rather than about React, and before the first route renders: the
// grid restores its own position and the browser must not answer the same question a second time.
// See lib/grid-anchor.ts for what that costs and what it buys.
claimScrollRestoration();

// A tab open across a deploy asks for chunks the new build no longer has: load the page again.
listenForStaleBuild();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
